// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3-lVA","content":"styles_content__1RlnT","selectAll":"styles_selectAll__3f4ky"};